export const QUIZ_QUESTIONS = [
  {
    key: "height",
    label: "Your height",
    helper: "Sizing is graded to your stature.",
    options: [
      { id: "5_9", label: "5'9\" — 5'10\"", sub: "175–178cm" },
      { id: "5_11", label: "5'11\" — 6'0\"", sub: "180–183cm" },
      { id: "6_1", label: "6'1\" and above", sub: "185cm+" },
    ],
  },
  {
    key: "wardrobe",
    label: "Where does it live in your week?",
    helper: "We'll lean the recommendation accordingly.",
    options: [
      { id: "lounge", label: "Mostly Lounge", sub: "Slow mornings, considered evenings." },
      { id: "active", label: "Mostly Active", sub: "Studio, run, recover." },
      { id: "both", label: "A little of both", sub: "An honest wardrobe." },
    ],
  },
  {
    key: "silhouette",
    label: "Your preferred silhouette",
    helper: "There's no wrong answer — only preference.",
    options: [
      { id: "relaxed", label: "Relaxed & oversized", sub: "Drop shoulder, generous body." },
      { id: "sculpted", label: "Sculpted & long", sub: "High-rise, considered seam lines." },
    ],
  },
  {
    key: "palette",
    label: "Your palette",
    helper: "Which way does your wardrobe lean?",
    options: [
      { id: "neutral", label: "Quiet neutrals", sub: "Greige, stone, mocha, cream." },
      { id: "contrast", label: "Heritage stripes", sub: "Burgundy & baby blue, cream & mocha." },
    ],
  },
  {
    key: "embroidery",
    label: "The TIA monogram",
    helper: "It's tonal, but still — your call.",
    options: [
      { id: "always", label: "Always embroidered", sub: "A quiet signature on every piece." },
      { id: "either", label: "I don't mind either way", sub: "Cut and fabric first." },
    ],
  },
];
